import axios from "axios"

import { API_URL } from "../../config/appConfig"
import { BASIC_STATUS } from "../../types/_enums"

const  ISSUER_BASE_URL = `${API_URL}/api/Issuers`

export const getCurrentBillingContactForIssuer = (issuerId: number) => {
  return axios.get(`${ISSUER_BASE_URL}/${issuerId}/currentbillingcontact`)
}

export const getAllIssuers = (headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/all`, { headers })
}

export const getListingContactForIssuer = (issuerId: number, headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/${issuerId}/listingcontacts`, { headers })
}

export const getInstrumentsForListingContact = (issuerId: number, contactId: number, headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/instrumentForContact/${contactId}?issuerId=${issuerId || null}`, { headers })
}

export const getPricingContactForIssuer = (issuerId: number, headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/${issuerId}/relations`, { headers })
}

export const postOrgIssuerRelation = (issuerId: number, payload: any) => {
  return axios.post(`${ISSUER_BASE_URL}/${issuerId}/relations`, payload)
}

export const getIssuersOnSearch = (payload: any) => {
  return axios.post(`${ISSUER_BASE_URL}/search`, payload)
}

export const getIssuer = (issuerId: number) => {
  return axios.get(`${ISSUER_BASE_URL}/${issuerId}`)
}

export const getFutureBillingCotacts = (issuerId: number, headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/${issuerId}/futurebillingcontacts`, { headers })
}

export const getAllBillingContactsForIssuer = (issuerId: number, headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/${issuerId}/allbillingcontacts`, { headers })
}

export const getCurrentBillingContacts = (headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/allcurrentbillingcontacts`, { headers })
}

export const getIssuersWithoutBillingContacts = (headers: any) => {
  return axios.get(`${ISSUER_BASE_URL}/issuerswithoutbillingcontact`, { headers })
}